import { render, staticRenderFns } from "./ModalFormDossie.vue?vue&type=template&id=0b614e10"
import script from "./ModalFormDossie.vue?vue&type=script&lang=js"
export * from "./ModalFormDossie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b614e10')) {
      api.createRecord('0b614e10', component.options)
    } else {
      api.reload('0b614e10', component.options)
    }
    module.hot.accept("./ModalFormDossie.vue?vue&type=template&id=0b614e10", function () {
      api.rerender('0b614e10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ModalFormDossie.vue"
export default component.exports